import { useEffect, useState } from "react";
import { callHistoryForDashboard } from "../store/api/CustomerApi";
import { Card, Col, Row } from "react-bootstrap";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis } from "recharts";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneSquare } from "@fortawesome/free-solid-svg-icons";

export default function CallDashboard() {
    const [callCount, getCallCount] = useState([]);
    const colorPalet = ["#053331","#32a89a","#a83257","#325da8","#7332a8","#e0a122","#91a8c2","#07274a","#4a0725","#32a852"]
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("InstallCount", "نصب ها").replace("RepairCount", "تعمیرها").replace("Count", "تعداد")}
                        </span>
                    ))
                }
            </>
        );
    }
    const uniqueColorForDataBar =(arrayName, propName)=>
    {
       const uniqueData = [new Set(callCount.Data[arrayName].map(a=> a[propName]))].sort();
       callCount.Data[arrayName].map(a=>{

       })


    }
    useEffect(() => {
        callHistoryForDashboard(getCallCount);
        document.body.classList = "notMain";
        document.Title = "بی همتا-مشتریان";
    }

        , [])

    return (

        <div className="container-fluid mt-2">
            <br />
            <Card className="card">
                <Card.Header className="headerStyle">داشبورد تماس ها</Card.Header>
                <Card.Body className="bodyStyle" >
                    {
                        callCount === "PENDING" ?
                            <Loader type="BallTriangle" width={50} height={50} className="loader" color="#bb1370"/>
                            :
                            <Row>
                                <Col md={7}>
                                    <Card className="newCard" style={{ "--mainColor": "#f64600e6", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg"  />
                                                &nbsp;
                                                <span className="cardTitle">تماس های 7 روز گذشته</span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.byUserAndDate) && callCount.Data.byUserAndDate.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.byUserAndDate} className="barChart">
                                                        <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="UserName" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                            {/* {
                                            callCount?.Data?.byUserAndDate.map(a=>a.PDate);
                                            } */}
                                                        <Bar dataKey="Count" fill="#468d94" label={{ position: 'top' }} isAnimationActive={false} />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>                                
                                <Col md={7}>
                                    <Card className="newCard" style={{ "--mainColor": "#f64600e6", height: "310px" }}>
                                        <Card.Header style={{ color: "black", border: "none", textAlign: "right" }}>
                                            <Card.Title>
                                                <FontAwesomeIcon icon={faPhoneSquare} size="lg"  />
                                                &nbsp;
                                                <span className="cardTitle">تماس ها به تفکیک ماه</span>
                                            </Card.Title>
                                            <div className="sepLine"></div>
                                        </Card.Header>
                                        <Card.Body>
                                            {Array.isArray(callCount?.Data?.perMonth) && callCount.Data.perMonth.length > 0 &&
                                                <ResponsiveContainer debounce={300}>
                                                    <BarChart data={callCount?.Data?.perMonth} className="barChart">
                                                        <Legend align="center" content={renderLegend} verticalAlign="bottom" />
                                                        <XAxis dataKey="MonthStr" style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} />
                                                        <CartesianGrid />
                                                        <Bar dataKey="Count" fill="#468d94" label={{ position: 'top' }} isAnimationActive={false} />
                                                    </BarChart>
                                                </ResponsiveContainer>
                                            }
                                        </Card.Body>

                                    </Card>
                                </Col>
                            </Row>}
                </Card.Body>
            </Card>
        </div>
    )
}